<template>
    <h1>Page not found</h1>
</template>